/**
 *
 * @param {*} notificationDetails
 * @returns an object with the field: updateType.
 * possible updateTypes:
 * 1) TRADE_PLAN_PNL_UPDATE (when a tradeplan completes, we send an update about the pnl for that trade plan)
 * 2) RESTART_TRADE_PLAN (when a trade plan restarts, we send an update about the various metrics for a
 * repeating trade plan (such as # of trades, pnl, isDeactivated, etc. these can be found in the statusDetails for
 * restartTradePlan))
 * 3) SETUP_TRIGGERED (the setup was triggered)
 * 4) ENTRY_TRIGGERED (the enter was triggered, this is if entry tactic is candle break. if the entry is market order
 * or limit order, it will just have setup triggered)
 * 5) OPTION_FILTER_FAILED (the entry failed because of an option filter)
 * 6) EXIT_TRIGGERED (exit tactic was triggered)
 * 7) SETUP_FILTERED (note this will in general cover the setup filters. There could also be cases of a
 * setup that gets filtered out on its own (lets say you do a candle pattern and terminate on pattern fail,
 * and all patterns fail), or the work order safety net
 * 8) NO_TARGETS_LEFT (such as if all candle magnitude targets are hit. the status will be TACTIC_TRIGGERED,
 * but all fields will be null/0 except the symbol and tacticName)
 */
export function tradePlanUpdateParser(notificationDetails) {
  const parsedObject = {
    updateType: null,
  };
  if (notificationDetails) {
    parsedObject.updateType = notificationDetails.updateType ?? null;
  }
  return parsedObject;
}
